import { PlaceType } from "../models/googleMaps";

interface GeocoderAddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

let geocoder: google.maps.Geocoder

export const setGeocoderInfo = async (placeType: PlaceType | null, location: any) => {
    if (!geocoder) {
        geocoder = new google.maps.Geocoder();
    }
    // const geocoder = { current: null };

    if (placeType == null || location == null) {
        return;
    }

    if (!geocoder) {
        return;
    }

    const geocoderResponse: google.maps.GeocoderResponse = await geocoder.geocode({ placeId: placeType.place_id })

    if (geocoderResponse && geocoderResponse.results && geocoderResponse.results.length > 0) {
        const info = geocoderResponse.results[0];
        location.placeId = info.place_id;
        location.latitude = info.geometry.location.lat();
        location.longitude = info.geometry.location.lng();
        location.longLocation = info.formatted_address;
        location.shortLocation = "";
        location.detailsJson = "";

        const addr = info.address_components as GeocoderAddressComponent[];
        const neighborhood = addr.find(a => a.types.includes('neighborhood'))?.long_name || "";
        const sublocality = addr.find(a => a.types.includes('sublocality'))?.long_name || "";
        const locality = addr.find(a => a.types.includes('locality'))?.long_name || "";

        location.country = addr.find(a => a.types.includes('country'))?.long_name || "";
        location.unitOrApartmentNumber = addr.find(a => a.types.includes('street_number'))?.long_name || "";
        location.street = addr.find(a => a.types.includes('route'))?.long_name || "";
        location.suburb = neighborhood || sublocality || locality || "";
        location.state = addr.find(a => a.types.includes('administrative_area_level_1'))?.long_name || "";
        location.postCode = addr.find(a => a.types.includes('postal_code'))?.long_name || "";
    }
}